export default {
  init() {
    // JavaScript to be fired on the articles pages
    (function($){

      function countLines(target) {
        var style = window.getComputedStyle(target, null);
        var height = parseInt(style.getPropertyValue('height'));
        var font_size = parseInt(style.getPropertyValue('font-size'));
        var line_height = parseInt(style.getPropertyValue('line-height'));
        var box_sizing = style.getPropertyValue('box-sizing');

        if(isNaN(line_height)) line_height = font_size * 1.2;

        if(box_sizing=='border-box')
        {
          var padding_top = parseInt(style.getPropertyValue('padding-top'));
          var padding_bottom = parseInt(style.getPropertyValue('padding-bottom'));
          var border_top = parseInt(style.getPropertyValue('border-top-width'));
          var border_bottom = parseInt(style.getPropertyValue('border-bottom-width'));
          height = height - padding_top - padding_bottom - border_top - border_bottom
        }
        var lines = Math.ceil(height / line_height);

        return lines;
      }

      function buildLineNumbers() {
        let main = $('article .entry-content');

        $('.paragraph-lines, .figure-lines').remove();

        // Paragraphs
        main.find('p, h1, h2, h3, h4, h5, h6').each(function() {
          let lines = countLines(this);
          let p = $(this);
          let style = window.getComputedStyle(this, null);
          let line_height = parseInt(style.getPropertyValue('line-height'));
          let inject = '';
          inject += '<div class="paragraph-lines" style="line-height: ' + line_height + 'px;">';
          for(var i = 0; i < lines; i++) {
            inject += '<div class="line-number"></div>'
          }
          inject += '</div>';
          p.prepend(inject);
        });

        main.find('figure, table').each(function() {
          let figure = $(this);
          let inject = '';
          inject += '<div class="figure-lines">';
            inject += '<div class="line-number"></div>'
          inject += '</div>';
          figure.prepend(inject);
        });
      }

      // Document Ready
      $(function() {
        if ($('body article').hasClass('status-draft')) {
          buildLineNumbers();

          $(window).breakpoints();

          $(window).bind('breakpoint-change', function() {
            buildLineNumbers();
          });
        }

        $('.c2g-display').on('cycle-before', function() {
          $('.c2g-display').addClass('slide-performed');
        });
      });

    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on the articles pages, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/singleArticle.js